var _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 55.5,
    fill: "#4F4F4F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_62_21)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 75,
    fill: "#767676",
    fillOpacity: 0.34
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5019 100.41H95.5093V105.393H98.4222C100.189 105.393 101.437 104.714 101.437 102.911C101.437 101.09 100.12 100.41 98.5019 100.41Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.65 91.1833C127.684 90.93 127.659 90.6723 127.578 90.43C127.497 90.1877 127.361 89.9672 127.182 89.7853C127.002 89.6034 126.784 89.4651 126.542 89.3807C126.301 89.2964 126.044 89.2684 125.79 89.2988C120.645 89.1989 115.495 89.2988 110.339 89.2538V85.3098H107.458C100.073 86.656 92.6843 87.9422 85.3 89.2636V123.766C92.6491 125.083 99.9982 126.339 107.348 127.69H110.339V123.816H124.799C125.621 123.766 126.529 123.816 127.232 123.318C127.795 122.425 127.65 121.323 127.7 120.326C127.65 110.628 127.735 100.896 127.65 91.1833ZM98.9025 108.432H95.5088V115.023H91.689V97.3715H98.9915C102.742 97.3715 105.288 99.4821 105.288 102.838C105.288 106.672 102.385 108.432 98.9025 108.432ZM126.234 122.285H110.339V118.341H122.863V116.347H110.339V113.904H122.863V111.909H110.339V109.466H122.863V107.472H110.339V104.979H122.863V103.06H110.339V100.567H122.863V98.6224H110.339V96.1546H122.863V94.1852H110.339V90.7346H126.234V122.285Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_62_21",
    x: 0.6,
    y: 0.6,
    width: 212.8,
    height: 212.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.7,
    result: "effect1_foregroundBlur_62_21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT3);
export default __webpack_public_path__ + "static/media/T3.a23a1eceb53196d6d8050f89fd3852ef.svg";
export { ForwardRef as ReactComponent };